import { createStyles } from '@mui/styles';
import { APTheme } from "../../../../core/TenantProvider/tenants";

export default (theme: APTheme) => createStyles({
  root: {
    marginLeft: -14,
    borderRight: '1px solid #CCC',
    '& .MuiOutlinedInput-input': {
      fontSize: 24,
      fontWeight: 'bold',
      padding: '10px 0 0 14px'
    },
    '& .MuiOutlinedInput-notchedOutline': {
      border: 0
    },
    '& .MuiFormLabel-root.Mui-focused': {
      color: 'rgba(0, 0, 0, 0.54)'
    }
  }
});
